import { get } from 'lodash';
import { Record } from 'immutable';

import {
  TestimonialAttachment,
  TestimonialRequest,
} from '~/types/models/testimonial';

export const RequestRecord = Record(
  {
    uuid: undefined,
    label: undefined,
    type: undefined,
    response: undefined,
    index: undefined,
  },
  'RequestRecord'
);

interface RequestProps extends Partial<TestimonialRequest> {
  index?: number;
}

export default class Request extends RequestRecord {
  constructor(args: RequestProps) {
    super({
      ...args,
      uuid: get(args, 'uuid'),
      label: get(args, 'label'),
      type: get(args, 'type'),
      response: get(args, 'response'),
      index: get(args, 'index'),
    });
  }

  /** Get the response of the file or link request */
  public getResponse(): TestimonialAttachment | null {
    return this.get('response');
  }
}
